/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { Block, ErrorMessage } from '@atoms';
import { TextField, EventField } from '@molecules';
import MediaField from '@organisms/MediaField';
import RichTextField from '@molecules/RichTextField';
import { NO_MARGIN_BOTTOM, NARROW_COL } from '@constants';
import { useIsSuperAdmin } from '@hooks';

import Form from '../Form';
import ContentModulesField from '../ContentModulesField';

import AudiencesField from './AudiencesField';
import SegmentsField from './SegmentsField';
import { FORM_FIELD } from './constants';

const EmailForm = ({ initialValues, onFinish, error, form }) => {
  const isSuperAdmin = useIsSuperAdmin();

  const handleOnValuesChange = ({ [FORM_FIELD.AUDIENCE.name]: audience }) => {
    if (audience) {
      // Can't use resetFields because it will reset to initial value in case of existing email
      // Set to undefined because null sets empty item but not choose option
      form.setFieldsValue({ [FORM_FIELD.SEGMENT.name]: undefined });
    }
  };

  return (
    <Form
      form={form}
      layout="vertical"
      initialValues={initialValues}
      onSerializedFinish={onFinish}
      onValuesChange={handleOnValuesChange}
    >
      <ErrorMessage error={error} variant="block" spaced />

      <Block spaced>
        <AudiencesField {...FORM_FIELD.AUDIENCE} />
        <Form.WithFieldValue name={FORM_FIELD.AUDIENCE.name}>
          {(value) => <SegmentsField {...FORM_FIELD.SEGMENT} disabled={!value} queryVariables={{ id: value?.id }} />}
        </Form.WithFieldValue>
        <EventField
          {...FORM_FIELD.EVENT}
          extra={null}
          wrapperCol={NARROW_COL}
          style={NO_MARGIN_BOTTOM}
          disabled={!isSuperAdmin}
        />
      </Block>

      <Block spaced>
        <MediaField {...FORM_FIELD.HEADER_IMAGE} />
        <TextField {...FORM_FIELD.TITLE} />
        <RichTextField {...FORM_FIELD.TEXT} style={NO_MARGIN_BOTTOM} />
      </Block>

      <ContentModulesField {...FORM_FIELD.CONTENT_MODULES} form={form} />
    </Form>
  );
};

EmailForm.useForm = () => Form.useForm(FORM_FIELD);
EmailForm.FORM_FIELD = FORM_FIELD;

export default EmailForm;
